// extracted by mini-css-extract-plugin
export default {"pageSpinner":"PageSpinner_pageSpinner__kCnBy","spinner":"PageSpinner_spinner__0EVle"};